import { Tooltip } from 'components/Tooltip';
import React from 'react';
import DatePicker from 'react-datepicker';

/** Props interface for DateRangeFilter component */
interface DateRangeFilterProps {
  label: string;
  value: { from: Date | null; to: Date | null } | undefined;
  onSelectedValueChange: (
    value: { from: Date | null; to: Date | null } | undefined,
  ) => void;
  labelWidth?: string;
}

/** DateRangeFilter Component for rendering date range inputs */
export const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  label,
  value,
  onSelectedValueChange,
  labelWidth,
}) => {
  const handleFromDateChange = (date: Date | null) => {
    let newValue =
      date || value?.to ? { from: date, to: value?.to || null } : undefined;
    onSelectedValueChange(newValue);
  };

  const handleToDateChange = (date: Date | null) => {
    let newValue =
      date || value?.from ? { from: value?.from || null, to: date } : undefined;
    onSelectedValueChange(newValue);
  };

  return (
    <div className="d-flex flex-row flex-fill flex-nowrap align-items-center border border-light rounded bg-light">
      {/* First column for label */}
      <div
        className="text-nowrap flex-grow-0 flex-shrink-0 text-dark px-2 font-weight-bold"
        style={labelWidth ? { width: labelWidth } : {}}
      >
        {label}
      </div>

      {/* Second column for the 'From' Date Picker */}
      <div className="flex-fill px-0 bg-white mr-1 border-0">
        <Tooltip
          id={`${label.replace(/\s+/g, '')}-from`}
          tooltip={
            value?.from ? (
              <>
                <strong>From:</strong> {value?.from.toString()}
              </>
            ) : (
              <>Click to select from date</>
            )
          }
        >
          <DatePicker
            selected={value?.from}
            onChange={handleFromDateChange}
            isClearable
            placeholderText="From"
            timeInputLabel="Time:"
            timeFormat="HH:mm"
            dateFormat="MM-dd-yy HH:mm"
            showTimeInput
            className="form-control border-0 w-100"
            popperPlacement="bottom"
            popperProps={{
              strategy: 'fixed',
            }}
          />
        </Tooltip>
      </div>

      {/* Third column for the 'To' Date Picker */}
      <div className="flex-fill bg-white px-0 border-0 rounded-right">
        <Tooltip
          id={`${label.replace(/\s+/g, '')}-to`}
          tooltip={
            value?.to ? (
              <>
                <strong>To:</strong> {value.to.toString()}
              </>
            ) : (
              <>Click to select to date</>
            )
          }
        >
          <DatePicker
            selected={value?.to}
            onChange={handleToDateChange}
            isClearable
            placeholderText="To"
            timeInputLabel="Time:"
            timeFormat="HH:mm"
            dateFormat="MM-dd-yy HH:mm"
            showTimeInput
            className="form-control flex-fill  border-0 w-100"
            popperPlacement="bottom"
            popperProps={{
              strategy: 'fixed',
            }}
          />
        </Tooltip>
      </div>
    </div>
  );
};
